// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"custom-css_wrapper__3TeZ-","btn":"custom-css_btn__19fZP","input":"custom-css_input__3CgP1"};